import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'odq-message-info',
    templateUrl: './message-info.component.html',
    styleUrls: ['./message-info.component.scss'],
    standalone: false
})
export class MessageInfoComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
